import type { ArticleContent } from "./types";
import { articleEn } from "./en";
import { articleFr } from "./fr";
import { articleDe } from "./de";
import { articleEs } from "./es";
import { articlePt } from "./pt";

export const articleContent: Record<string, Record<string, ArticleContent>> = {
  en: articleEn,
  fr: articleFr,
  de: articleDe,
  es: articleEs,
  pt: articlePt,
};

export const defaultLanguage = "en";